import React from "react";
import { useNavigate } from 'react-router-dom' ;
import './index.scss';

const Footer = () => {
    const prefixCls = 'footer'

    const navigate = useNavigate();

    const footerTextList = [
        {
            title: '关于我们',
            children:[
                {title: '公司简介',key: 'aboutUs'},
                {title: '联系我们',key: 'connectUs'},
                // {title: '企业动态'},
                // {title: '技术分享'},
            ]
        },
        {
            title: '服务项目',
            children:[
                {title: '软件定制开发',key: 'sofeware'},
                // {title: '微信开发'},
                // {title: 'app应用开发'},
                // {title: '企业信息化建设'},
            ]
        },
        {
            title: '核心产品',
            children:[
                // {title: '工作流系统'},
                {title: '地铁管理系统',key: 'metro'},
                {title: '医疗管理系统',key: 'hospitol'},
                {title: '餐饮成本管理系统',key: 'food'},
            ]
        },
    ]

    const handleClick = (key:string) => {
        switch (key) {
            case 'aboutUs':
                navigate('/server/aboutUs');
                break;
            case 'connectUs':
                navigate('/connectUs');
                break;
            case 'sofeware':
                navigate('/server/sofeware');
                break;
            default:
              break;
          }
    }

    return <div style={{width:'100%'}}>
    <div className={`${prefixCls}`}>
    <div className={`${prefixCls}-content`}>
        {footerTextList.map((item)=>{
            return <div className={`${prefixCls}-content-item`}>
                <div className={`${prefixCls}-title`}>{item.title}</div>
                {item.children.length>0 && item.children.map((item)=>{
                    return <div className={`${prefixCls}-subtitle`}
                    // onClick={ () => navigate('./connectUs') }
                     onClick={() => {
                        if (item.key) {
                            handleClick(item.key);
                        }
                     }} 
                     style={{display:'block'}}>
                        {item.title}
                    </div>
                })}
            </div>
        })}
    </div>
    <div className={`${prefixCls}-contact`}>
        {/* <div>地址：陕西省&nbsp;&nbsp;</div>  */}
        <div>联系电话：15249118888&nbsp;&nbsp;</div>
        <div>邮箱：173025071@qq.com</div>
    </div>
</div>
<div className={`${prefixCls}-copy`} >
    <a href="https://beian.miit.gov.cn/" target="_blank" style={{textDecoration: "none",color: "inherit"}}>
        ©2024 陕西图南数字科技有限公司&nbsp;&nbsp;陕ICP备2024036564号-2
    </a>
        {/* <div>©2024 陕西图南数字科技有限公司&nbsp;&nbsp;</div>
        <div style={{marginLeft:'10px'}}>陕ICP备2024036564号-1</div> */}
</div>
</div>
}

export default Footer;